import {
  CollectAssistantIcon,
  EfficiencyAssistantIcon,
  FeedbackAssistantIcon,
  GoalAssistantIcon,
  IncidentAssistantIcon,
  ProductAssistantIcon,
  ProjectAssistantIcon,
  RequirementAssistantIcon,
  VirtualEmployeeAssistantIcon,
} from '@/constants/moduleIcons'
import {
  collectRouteCandidates,
  efficiencyRouteCandidates,
  feedbackRouteCandidates,
  goalRouteCandidates,
  incidentRouteCandidates,
  productManagementRouteCandidates,
  projectRouteCandidates,
  requirementRouteCandidates,
  toAnyPermission,
  virtualEmployeeRouteCandidates,
} from '@/config/businessRoutePermissions'
import type { PermissionedMenuItem } from '@/types/permission'
import { canAccessPermissionRequirement } from '@/utils/permission'

export const userNavigationItems: PermissionedMenuItem[] = [
  {
    key: 'goals',
    label: '目标',
    title: '目标管理助手',
    icon: GoalAssistantIcon,
    route: '/goals/okr',
    activePrefix: '/goals',
    permission: toAnyPermission(goalRouteCandidates),
    defaultRouteCandidates: goalRouteCandidates,
  },
  {
    key: 'products',
    label: '产品',
    title: '产品管理助手',
    icon: ProductAssistantIcon,
    route: '/products',
    permission: toAnyPermission(productManagementRouteCandidates),
    defaultRouteCandidates: productManagementRouteCandidates,
  },
  {
    key: 'portfolio',
    label: '重点',
    title: '重点项目对齐',
    icon: ProjectAssistantIcon,
    route: '/portfolio/alignments',
    activePrefix: '/portfolio',
    permission: 'project:alignment:view',
  },
  {
    key: 'projects',
    label: '项目',
    title: '项目管理助手',
    icon: ProjectAssistantIcon,
    route: '/projects',
    permission: toAnyPermission(projectRouteCandidates),
    defaultRouteCandidates: projectRouteCandidates,
  },
  {
    key: 'requirements',
    label: '需求',
    title: '需求管理助手',
    icon: RequirementAssistantIcon,
    route: '/requirements',
    permission: toAnyPermission(requirementRouteCandidates),
    defaultRouteCandidates: requirementRouteCandidates,
  },
  {
    key: 'incidents',
    label: '故障',
    title: '故障管理助手',
    icon: IncidentAssistantIcon,
    route: '/incidents',
    permission: toAnyPermission(incidentRouteCandidates),
    defaultRouteCandidates: incidentRouteCandidates,
  },
  {
    key: 'virtual-employee',
    label: '虚拟',
    title: '虚拟员工',
    icon: VirtualEmployeeAssistantIcon,
    route: '/virtual-employee',
    permission: toAnyPermission(virtualEmployeeRouteCandidates),
    defaultRouteCandidates: virtualEmployeeRouteCandidates,
  },
  {
    key: 'feedback',
    label: '反馈',
    title: '反馈助手',
    icon: FeedbackAssistantIcon,
    route: '/feedback',
    permission: toAnyPermission(feedbackRouteCandidates),
    defaultRouteCandidates: feedbackRouteCandidates,
  },
  {
    key: 'efficiency',
    label: '人效',
    title: '人效助手',
    icon: EfficiencyAssistantIcon,
    route: '/efficiency',
    permission: toAnyPermission(efficiencyRouteCandidates),
    defaultRouteCandidates: efficiencyRouteCandidates,
  },
  {
    key: 'collect',
    label: '采集',
    title: '数据采集中心',
    icon: CollectAssistantIcon,
    route: '/collect',
    permission: toAnyPermission(collectRouteCandidates),
    defaultRouteCandidates: collectRouteCandidates,
  },
]

export function filterUserNavigationItems(
  items: PermissionedMenuItem[],
  permissions: string[],
  isAdmin = false
): PermissionedMenuItem[] {
  return items.filter(item => canAccessPermissionRequirement(item.permission, permissions, isAdmin))
}
